import script from "./AppTextarea.vue?vue&type=script&setup=true&lang=js"
export * from "./AppTextarea.vue?vue&type=script&setup=true&lang=js"

import "./AppTextarea.vue?vue&type=style&index=0&id=256973f6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-256973f6"]])

export default __exports__